module.exports = __webpack_public_path__ + "img/pcimg.93e866b8.jpg";